import * as React from 'react';

const CircleIcon = (): React.ReactElement => {
  return <span className="circle-icon"></span>;
};

export default CircleIcon;
